import classNames from 'classnames';
import { Header } from 'components/ui-blocks/header';
import React from 'react';
import FontAwesome from 'react-fontawesome';

import styles from './ModalHeader.module.scss';

interface Props {
  title?: string;
  children: React.ReactNode;
  onClose?: () => void;
  colorVariant?: 'default' | 'white' | 'transparent' | 'lightGray' | 'darkGray';
  /** @todo see ModalContent+Footer */
  withForm?: boolean;
  className?: string;
}
const ModalHeader = (props: Props) => (
  <Header
    className={classNames(styles.modalHeader, props.className, {
      [styles.withForm]: props.withForm,
    })}
    colorVariant={props.colorVariant}
  >
    {!!props.title && <h3 className={styles.title}>{props.title}</h3>}
    {props.children}
    {!!props.onClose && (
      <div className={styles.close} onClick={props.onClose} data-testid="close-modal-button">
        <FontAwesome name="times" />
      </div>
    )}
  </Header>
);
export default ModalHeader;
